import { storeName } from '@/store/utils/local-storage';
const key = 'blt_tab_id';

const MAX_TIME_ALIVE = 30 * 60 * 1000; // 30 min

export const getTabId = (from) => {
  let tabId = sessionStorage.getItem(key);

  if (!tabId) {
    console.error(`Tab id not found in ${from} , generating new one`);
    tabId = crypto.randomUUID();
    sessionStorage.setItem(key, tabId);
  }

  updateActiveTabs(tabId);
  return tabId;
};

export const cleanUnusedTabs = () => {
  const activeTabs = getActiveTabs();
  const now = Date.now();

  let cleaned = false;

  for (const tabId in activeTabs) {
    const lastActive = activeTabs[tabId];

    if (now - lastActive > MAX_TIME_ALIVE) {
      localStorage.removeItem(`${storeName}-${tabId}`);

      delete activeTabs[tabId];
      cleaned = true;
    }
  }

  if (cleaned) {
    setItems(activeTabs);
  }
};

function getActiveTabs() {
  return JSON.parse(localStorage.getItem('activeTabs')) || {};
}

function setItems(items) {
  localStorage.setItem('activeTabs', JSON.stringify(items));
}

function updateActiveTabs(tabId) {
  const activeTabs = getActiveTabs();

  activeTabs[tabId] = Date.now();

  setItems(activeTabs);
}
